import { render, staticRenderFns } from "./Writing.vue?vue&type=template&id=b8976020&scoped=true"
import script from "./Writing.vue?vue&type=script&lang=js"
export * from "./Writing.vue?vue&type=script&lang=js"
import style0 from "./Writing.vue?vue&type=style&index=0&id=b8976020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8976020",
  null
  
)

export default component.exports